export const MarqueeImage = ({ images, testId }) => {
  const items = [...images, ...images];
  return (
    <div data-testid={testId} className="w-full h-[240px] md:h-[360px] overflow-hidden rounded-2xl shadow-xl">
      <div className="marquee-track flex h-full w-max" style={{ animationDuration: `${images.length * 4}s` }}>
        {items.map((src, i) => (
          <img
            key={i}
            src={src}
            alt=""
            aria-hidden={i >= images.length}
            className="h-full aspect-[3/4] shrink-0 object-cover"
          />
        ))}
      </div>
    </div>
  );
};
